// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"VariantTypeSelection_dropdown__3eNf3"};